var _metadata, _sodipodiNamedview, _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 281,
    height: 285,
    viewBox: "454.88 82.735 281 285",
    xmlSpace: "preserve",
    id: "svg27",
    sodipodiDocname: "built.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata31"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 640,
    "inkscapeWindow-height": 480,
    id: "namedview29",
    "fit-margin-top": 15,
    "fit-margin-left": 15,
    "fit-margin-right": 15,
    "fit-margin-bottom": 15
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc2"
  }, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 281.20001,
    height: 285.20001,
    fillOpacity: 0,
    x: 454.88,
    y: 82.735001,
    id: "rect6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.81,0,0,0.81,593,224.5)",
    id: "main_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.05,0,0,-0.05,4.17,-4.17)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0c8981",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(-5339.21,-5276.59)",
    d: "m 5160,8470 c -100,-14 -161,-55 -269,-179 l -51,-59 77,-55 c 113,-80 540,-516 1268,-1296 181,-194 234,-250 320,-341 50,-52 132,-139 183,-193 l 92,-98 v -100 c 0,-54 -3,-99 -7,-99 -4,0 -45,37 -92,83 -47,45 -160,152 -251,237 -377,355 -568,538 -1015,971 -258,251 -497,479 -530,508 -78,67 -148,94 -241,93 -132,-1 -121,8 -615,-490 -243,-246 -699,-706 -1013,-1022 -605,-609 -613,-618 -631,-727 -8,-52 15,-147 51,-205 30,-50 196,-214 369,-366 66,-58 174,-154 240,-213 121,-108 344,-302 580,-504 70,-60 196,-169 279,-240 83,-72 185,-158 226,-192 137,-113 610,-518 826,-708 50,-44 130,-114 179,-155 48,-41 106,-91 129,-111 22,-20 97,-86 166,-147 69,-60 180,-163 246,-228 67,-66 207,-203 312,-305 154,-151 203,-193 255,-219 l 64,-31 h 728 c 521,1 732,4 742,12 11,10 13,213 13,1183 v 1171 l 91,95 c 291,302 355,382 395,485 15,40 19,76 19,180 0,155 -20,231 -95,355 -87,145 -163,232 -517,590 l -353,357 -2,899 -3,899 h -280 -280 l 2,-612 c 1,-463 -2,-613 -10,-613 -7,0 -305,293 -662,651 -358,357 -670,665 -695,683 -70,52 -145,69 -240,56 z M 4852,6966 c 110,-132 240,-288 288,-346 275,-329 390,-474 383,-481 -5,-5 -64,-10 -132,-11 l -124,-3 v -286 c 0,-157 2,-290 5,-295 4,-5 119,-9 265,-8 l 258,1 3,142 c 2,89 6,141 13,139 5,-2 35,-35 67,-74 62,-78 242,-292 417,-499 61,-71 151,-179 200,-240 49,-60 135,-162 190,-225 130,-147 225,-269 225,-287 0,-8 -87,-102 -192,-210 -260,-264 -298,-305 -295,-323 1,-8 9,-16 18,-18 12,-2 670,656 1231,1233 53,55 100,96 105,92 7,-8 8,-91 4,-638 l -1,-166 -122,-129 c -68,-72 -203,-218 -302,-325 -175,-190 -254,-274 -546,-574 -80,-82 -229,-238 -330,-345 -101,-107 -273,-285 -382,-395 l -198,-200 -40,40 -41,41 1,397 c 0,237 -4,397 -9,397 -5,0 -33,-27 -62,-60 -29,-33 -56,-60 -60,-60 -4,0 -61,60 -125,133 -64,72 -178,202 -253,287 -75,85 -164,188 -198,229 l -63,75 v 648 c 0,398 -4,649 -10,653 -8,5 -237,8 -437,6 l -83,-1 v -350 c 0,-198 -4,-350 -9,-350 -5,0 -87,93 -182,207 -96,113 -217,256 -269,317 -87,100 -385,460 -597,720 -46,55 -83,106 -83,112 0,6 17,27 38,46 51,49 1059,1072 1145,1163 39,41 74,72 79,69 5,-4 100,-115 210,-248 z M 7311,3583 c 1,-148 1,-303 1,-345 l 1,-77 -174,-188 c -96,-103 -255,-273 -354,-378 -99,-104 -209,-221 -246,-260 -36,-38 -85,-92 -109,-118 -71,-78 -103,-87 -181,-47 -28,14 -289,271 -289,284 0,14 83,102 600,636 152,157 379,392 505,522 127,131 233,238 238,238 4,0 7,-120 8,-267 z",
    strokeLinecap: "round",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.05,0,0,-0.05,-19.9,-27.95)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0c8981",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(-4784.01,-5831.13)",
    d: "m 4525,6121 c -10,-18 -6,-564 5,-575 13,-13 478,-17 503,-4 16,8 17,30 15,296 l -3,287 -257,3 c -156,1 -259,-1 -263,-7 z",
    strokeLinecap: "round",
    id: "path12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.05,0,0,-0.05,17.17,36.19)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0c8981",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(-5535.45,-4519.4)",
    d: "m 5388,5282 -118,-3 v -277 c 0,-152 0,-495 0,-762 v -485 h 252 c 139,0 259,2 266,4 16,4 18,1506 1,1517 -12,7 -223,10 -401,6 z",
    strokeLinecap: "round",
    id: "path16"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.05,0,0,-0.05,-63.49,70.51)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0c8981",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(-3940.43,-3799.78)",
    d: "m 2208,5468 c -145,-220 -177,-624 -67,-866 83,-185 283,-409 523,-587 l 27,-20 v -952 c 0,-589 3,-955 9,-958 15,-9 3093,-6 3102,3 12,12 -1,21 -122,84 -122,64 -163,87 -219,122 -22,15 -43,26 -46,26 -3,0 -50,27 -105,60 -54,33 -113,68 -132,78 -18,11 -73,44 -123,74 -49,31 -189,115 -310,188 -121,73 -253,155 -293,182 -40,26 -75,48 -78,48 -3,0 -20,11 -38,25 -18,14 -36,25 -39,25 -3,0 -42,24 -86,53 -44,28 -171,110 -283,182 -112,71 -261,167 -333,214 -71,47 -139,90 -150,96 -24,14 -188,123 -310,206 -49,35 -130,90 -180,124 -188,129 -426,318 -524,417 -74,75 -145,178 -160,233 -7,26 -11,202 -11,518 0,262 -4,477 -9,477 -4,0 -24,-24 -43,-52 z",
    strokeLinecap: "round",
    id: "path20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e3de9059d51dc0f809394916232de988.svg";
export { ForwardRef as ReactComponent };